import React from "react"
import CustomCalendarButton from "../CustomCalendarButton"
import { CalendarDate } from "../types"
import classes from "./CustomCalendarDay.module.css"

interface Props {
  date: CalendarDate | undefined
  clickable: boolean
  onClick?: () => void
  className?: string
  selected?: boolean
}

const CustomCalendarDay = ({
  date,
  clickable,
  onClick,
  selected,
  className,
}: Props) => {
  return (
    <div className={`${classes.day} ${className ?? ""}`}>
      <CustomCalendarButton
        disabled={!clickable}
        selected={selected}
        onClick={onClick}
        withBackground
      >
        {date?.day ?? ""}
      </CustomCalendarButton>
    </div>
  )
}

export default CustomCalendarDay
